export default __webpack_public_path__ + "static/media/hht1_storybook_01.70a8d0a0.png";